import React, { useState } from "react";
import classes from "./BlankWorkbookCard.scss";
import { AddOutlined } from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";
import classNames from "classnames";

const BlankWorkbookCard = props => {
  const { className, createBlankWorkbook } = props;
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useI18n();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const iconVariant = isHovered ? "default" : "subtle";
  const containerStyle = classNames(className, classes.blankContainer);

  return (
    <div
      className={containerStyle}
      onClick={createBlankWorkbook}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <AddOutlined variant={iconVariant} size="x-small" />
      <div className="text-label-3">{t("workbook:blank_workbook")}</div>
    </div>
  );
};

export default BlankWorkbookCard;
